// extracted by mini-css-extract-plugin
export default {"container":"container-rKlOg","icon":"icon-n3F88","label":"label-Jv8uu","button":"button-ESTTr"};